import React from "react";
import "./css/AboutUs.css";
import headerBg from "./assets/picOne.png"; // reuse or replace with a relevant image

const NQIFeedbackForm = () => {
  return (
    <div className="about-us">
      {/* === Header Section === */}
      <section className="about-header">
        <div className="overlay">
          <h1 className="page-title">NQI Feedback Form</h1>
          <p className="subtitle">
            The Malawi Bureau of Standards (MBS) National Quality Institute (NQI) provides a feedback form 
            to gather stakeholder input on verification, calibration, and quality services.
          </p>
          <p className="subtitle">
            Feedback helps MBS improve service delivery, enhance stakeholder satisfaction, and ensure continuous quality improvement.
          </p>
        </div>
      </section>

      {/* === Purpose of Feedback Section === */}
      <section className="intro-section">
        <h2 className="section-title">Purpose of the Feedback Form</h2>
        <div className="row">
          <div className="col-md-6">
            <ul>
              <li>Collect stakeholder opinions on NQI services</li>
              <li>Identify areas for improvement in verification and calibration services</li>
              <li>Enhance the quality and reliability of NQI operations</li>
              <li>Ensure stakeholder satisfaction and engagement</li>
              <li>Support compliance with national and international standards</li>
            </ul>
          </div>
          <div className="col-md-6">
            <ul>
              <li>Facilitate transparent communication between MBS and its stakeholders</li>
              <li>Gather suggestions for training, workshops, and capacity building</li>
              <li>Monitor performance and effectiveness of NQI programs</li>
              <li>Promote continuous improvement in service delivery</li>
              <li>Support decision-making and strategic planning for quality services</li>
            </ul>
          </div>
        </div>
      </section>

      {/* === Submission Guidelines Section === */}
      <section className="functions-section">
        <h2 className="section-title">Submission Guidelines</h2>
        <p>
          Stakeholders can submit the NQI Feedback Form electronically or physically. MBS ensures that all feedback is reviewed, acknowledged, and addressed promptly.
        </p>
        <ul>
          <li>Provide accurate and relevant information</li>
          <li>Include your organization and contact details for follow-up</li>
          <li>Clearly describe your experience, suggestions, or concerns</li>
          <li>Submit the form via email or at the NQI office</li>
          <li>Expect acknowledgment and response within a reasonable timeframe</li>
        </ul>
      </section>

      {/* === Contact Section === */}
      <section className="functions-section">
        <h2 className="section-title">Contact for Feedback</h2>
        <p>
          For inquiries regarding the NQI Feedback Form or submission process, please contact the MBS National Quality Institute team.
        </p>
        <div className="row">
          <div className="col-md-6">
            <ul>
              <li>Email: <a href="mailto:nqi@mbs.mw">nqi@mbs.mw</a></li>
              <li>Phone: +265 (0) 1 789 111</li>
            </ul>
          </div>
          <div className="col-md-6">
            <ul>
              <li>Office: Malawi Bureau of Standards, P.O. Box 946, Blantyre, Malawi</li>
              <li>Website: <a href="https://www.mbs.mw">www.mbs.mw</a></li>
            </ul>
          </div>
        </div>
        <p className="subtitle">
          The NQI Feedback Form enables MBS to improve services, respond to stakeholder needs, and maintain high standards of quality, verification, and calibration.
        </p>
      </section>

      <br /><br />
    </div>
  );
};

export default NQIFeedbackForm;
